export const dateFormatter = (function () {
  const dateSepRegx = /[/ :]/g;
  const getDateByFormat = (date, format) => {
    switch (format) {
      case 'DD':
        const day = String(date.getDate());
        return `${day.length <= 1 ? '0' : ''}${day}`;
      case 'MM':
        const month = String(date.getMonth() + 1);
        return `${month.length <= 1 ? '0' : ''}${month}`;
      case 'YY':
        return `${date.getFullYear()}`.slice(2);
      case 'hh':
        const h = `${date.getHours()}`;
        return `${h.length <= 1 ? '0' : ''}${h}`;
      case 'mm':
        const m = `${date.getMinutes()}`;
        return `${m.length <= 1 ? '0' : ''}${m}`;
      default:
        return ''
    }
  };

  return {
    format: (date, format = 'DD/MM/YY hh:mm') => {
      const newDate = new Date(date);
      const sep = ['', ...format.match(dateSepRegx)];

      return format.split(dateSepRegx).reduce((d, f, i) => {
        const s = sep[i] || '';
        return `${d}${s}${getDateByFormat(newDate, f)}`
      }, '')
    },
  };
})();
